var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kst-skeleton"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],staticClass:"mb-4"},[_vm._v(_vm._s(_vm.AppCatalog.Message.Wait))]),(!_vm.simpleMode)?_vm._l((_vm.total),function(index){return _c('b-skeleton',{key:index,attrs:{"size":"is-large","active":_vm.active}})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }